import { Component, Input, OnInit } from '@angular/core';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { ConfigurationService } from '../../services/configuration.service';
import {
  BaseComponent,
  getUrlParams,
  UserActionService,
} from '../../../shared';
import { Session } from '../../services/session.service';
import { LogService } from '../../services/log.service';
import { UserActions } from 'src/app/shared/models/user';
import { Router } from '@angular/router';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-comm-center2-card',
    template: `
    <app-panel
      title=""
      class="tw-cursor-pointer "
      border="Empty"
      [shadow]="true"
      [canExpand]="false"
      tabindex="-1"
      >
      <div class=" container ">
        <div
          class="tw-w-full tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-h-full "
          >
          <div class="tw-w-[30%] tw-place-self-center">
            <div class="tw-grid tw-grid-cols-1">
              <div class="tw-place-self-center">
                <img
                  src="./assets/images/comm-center/25-674_SEDG_mySedgwick_Rebrand_Icon_CommCenter.png"
                  class="icon"
                  width="160px"
                  alt=""
                  />
                </div>
              </div>
            </div>
            <div class="tw-px-4 tw-w-[70%]">
              <div class="tw-flex tw-flex-col ">
                <div class=" tw-leading-loose tw-tracking-wide text-container">
                  <h2
                    class="header1-text  tw-text-[20px] md:tw-text-[26px] "
                    role="heading"
                    >
                    {{ 'Communication center' | translation: translationRequest }}
                  </h2>
                  <br />
                  <span class="header2-text"
                    >
                    {{ 'Have questions regarding a claim?' | translation: translationRequest }}
                  </span>
                  <br />
                  <span class="header3-text ">
                    {{ 'Visit the communication center to send messages directly to' | translation: translationRequest }} {{ examinerLabel | aliasTransform:'none' }}. {{ 'Responses are provided within one business day.' | translation: translationRequest }}
                  </span>
                </div>
                <div class="app-mb1 app-pt2" tabindex="-1">
                  <app-button
                    emphasis="High"
                    tabindex="-1"
                    [arialabel]="'Visit Communication center'"
                  (click)="
                    cardClick(
                      'CommunicationCenter',
                      'Communication Center',
                      urlParams
                    )
                  "
                    [role]="'link'"
                    label="Visit"
                    >
                  </app-button>
                </div>
              </div>
            </div>
            <div>
              @if (session.user.leaveType === 'LeaveLink') {
                <app-toast
                  class=" tw-place-self-center"
                  type="Info"
                  >
                  {{ 'LeaveLink claims will not be displayed in the Communication Center.' | translation: translationRequest }}
                </app-toast>
              }
            </div>
          </div>
        </div>
      </app-panel>
    `,
    styles: `
  .icon {

    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 54px;
  }

  .header1-text  {
    letter-spacing: 0.8px;
    font-weight: 300;
    color: var(--color-input-grey);
  }

  .header2-text  {
    letter-spacing: 0.5px;
    font-size: 15px;
    font-weight: bold;
    color: var(--color-input-grey);
  }

  .header3-text  {
    font-size: 14px;
    color: var(--color-input-grey);
  }

  .container {
    padding: 10px 16px 16px 16px;
    height: 425px;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 12px !important;
  }`,
    standalone: false
})
export class CommCenter2CardComponent extends BaseComponent implements OnInit {
  examinerLabel: Aliases;
  urlParams: any;

  @Input()
  translationRequest: TranslationRequest;

  constructor(
    private alias: InpageAliasService,
    private configService: ConfigurationService,
    public session: Session,
    private logService: LogService,
    private userAction: UserActionService,
    private router: Router
  ) {
    super();
  }

  async ngOnInit() {
    const config = await this.configService.getAdditionalUserInformation();
    this.examinerLabel = await this.alias.replaceAliases(
      'examinerSingular',
      config.configFeatures.aliases
    );
    this.urlParams = getUrlParams();
  }

  cardClick(featureName: string, tabName: string, queryParams: any) {
    let cardLocation = 'Card';
    const managerAction = this.userAction.getAction();

    if (managerAction == UserActions.ViewOwnMgrDb) {
      cardLocation = 'Managers View Card';
    } else if (managerAction == UserActions.MgrViewEmpDb) {
      cardLocation = 'Managers Employee View Card';
    } else if (managerAction == UserActions.ViewOwnEmpDb) {
      cardLocation = 'Managers own Card';
    } else if (managerAction == UserActions.ManagerSummaryView) {
      cardLocation = 'Summary View Card';
    }

    this.FeatureLogging(featureName, tabName, cardLocation);

    if (featureName == 'CommunicationCenter') {
      this.router.navigate(['/communication-center'], {
        queryParams,
      });
    }
  }
}
